<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

addEventListener("DOMContentLoaded", (event) => {
    if (document.querySelector(".articleLookbook-item")) {
        var collDescDiv = document.querySelector(".articleLookbook-item .articleLookbook-des");
        var collReadmore = document.querySelector(".articleLookbook-item .read-more");
        
        if (collReadmore) {
              var collDescHeight = collDescDiv.offsetHeight;
              var collDescHeightpx = collDescDiv.offsetHeight + 'px';

              collDescDiv.style.height = collDescHeightpx;
              console.log('se ', collDescHeight);
          if (collDescHeight >= 50) {      
              collReadmore.style.display = "block";
              collReadmore.addEventListener('click', function() {
                  collDescDiv.classList.toggle('open');
                  collReadmore.classList.toggle('open');
              })      
          }
     
        }
    }
})  
